import axios from './financeiroApi';

const getPath = () => `/api/v1/backend/usuario`;

const usuarioApi = {
  get: (search) => {
    const url = `${getPath()}?page=${search.page}&size=${search.size}${
      search.q ? `&q=${search.q}` : ''
    }&sort=${search.sort || 'nome,ASC'}`;

    return axios.get(url);
  },
  getOne: (usuarioId) => {
    const url = `${getPath()}/${usuarioId}`;
    return axios.get(url);
  },
  put: (usuario) => {
    const url = `${getPath()}/${usuario.id}`;
    return axios.put(url, usuario);
  },
  delete: (filtro) => {
    return axios.delete(getPath(), { data: filtro });
  },
  cadastrar: async (usuario) => {
    return axios.post(getPath(), usuario, {
      headers: {
        origem: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
      },
    });
  },
  validarLimiteUsuarioPorPlano: async () => {
    return axios.get(`${getPath()}/limite-plano-comercial`);
  },
  buscarUuidUsuarioLogado: async () => {
    const url = `${getPath()}/buscar-usuario-logado`;
    return axios.get(url);
  },

  buscarUsuarioClienteLogado: async () => {
    const url = `${getPath()}/buscar-usuario-cliente-logado`;
    return axios.get(url);
  },
  alterarSenhaUsuarioKeycloak: async (dadosAlterarSenha) => {
    return axios.put(`${getPath()}/alterar-senha-keycloak`, dadosAlterarSenha);
  },
  validarPermissaoAcessoKeycloak: (ipRede) => {
    return axios.get(`${getPath()}/validar-permissao-acesso-token?ipRede=${ipRede}`);
  },
  validarAcessoCliente: () => {
    return axios.get(`${getPath()}/validar-acesso-cliente`);
  },
  solicitarDesbloqueio: () => {
    return axios.get(`${getPath()}/enviar-email-liberar-acesso`);
  },
  updateAtalhos: (user) => {
    return axios.post(`${getPath()}/update-atalhos`, user);
  },
  buscarAtalhos: () => {
    return axios.get(`${getPath()}/buscar-atalhos`);
  },
  buscarTour: () => {
    return axios.get(`${getPath()}/buscar-tour`);
  },
  updateTour: (funcionalidades) => {
    return axios.post(`${getPath()}/update-tour?funcionalidades=${funcionalidades}`);
  },
};

export { usuarioApi };
